import getEnvVar from '@/lib/getEnvVar'
import SETTINGS from '@/src/settings'

export const getDomainSetting = setting => {
  switch (getEnvVar('APP_ENV')) {
    case 'staging':
      return SETTINGS.staging[setting]
    case 'production':
      return SETTINGS.production[setting]
    default:
      return SETTINGS.dev[setting]
  }
}
